<div
  lass="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex"
>
  <app-breadcrumb [items]="breadcrumbItems" class="px-5"></app-breadcrumb>
  <div
    class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex"
  >
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div class="bg-white shadow-sm-light">
        <app-info-appel
          [base]="'application'"
          [cohorte]="cohorte"
        ></app-info-appel>

        <div class="border-b border-gray-200 dark:border-gray-700">
          <ul
            class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
          >
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/candidatures/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd"
                  />
                </svg>

                Candidatures******************
              </a>
            </li>
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/deliberation/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                aria-current="page"
              >
                <svg
                  class="w-6 h-6 text-blue-600 mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Zm-1 9a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm2-5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 4a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z"
                    clip-rule="evenodd"
                  />
                </svg>
                Déliberation
              </a>
            </li>
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/admis/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                    clip-rule="evenodd"
                  />
                </svg>

                Admis
              </a>
            </li>
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/nonadmis/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm5.757-1a1 1 0 1 0 0 2h8.486a1 1 0 1 0 0-2H7.757Z"
                    clip-rule="evenodd"
                  />
                </svg>
                Non&nbsp;Admis
              </a>
            </li>
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/statistiques/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v15a1 1 0 0 0 1 1h15M8 16l2.5-5.5 3 3L17.273 7 20 9.667"
                  />
                </svg>
                Statistiques...
              </a>
            </li>
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/test/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd"
                  />
                </svg>
                Test&nbsp;d'admission
              </a>
            </li>
            <!-- <li>
            <a
              class="inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500"
              >Disabled</a
            >
          </li> -->
          </ul>
        </div>
      </div>
      <!-- </div> -->
      <div
        class="text-center w-full p-8 bg-white delib-screen flex-col justify-start items-start gap-2.5 inline-flex"
      >
        <div
          class="text-center w-full p01 p-8 bg-white flex-col justify-start items-start gap-2.5 inline-flex"
        >
          <div
            class="self-stretch h-full flex-col justify-start items-start gap-5 flex"
          >
            <div
              class="self-stretch flex-col justify-start items-center gap-3 flex"
            >
              <div
                class="self-stretch flex-col justify-start items-start gap-6 flex"
              >
                <div
                  class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex"
                >
                  <div
                    class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
                  >
                    <div
                      class="self-stretch text-gray-900 text-3xl font-semibold mt-5"
                    >
                      Répartitions des candidatures
                    </div>
                  </div>
                </div>
                <div class="pad pad-fields">
                  <div
                    class="titre-ctnr justify-center w-full self-stretch justify-start gap-4 inline-flex"
                  >
                    <div class="titre f16 font-semibold p-2">
                      Total des candidats
                    </div>
                    <div
                      class="nom f16 text-center font-semibold bg-blue-100 px-3 py-2 w-full rounded-lg"
                    >
                      {{ totalFem + totalHom }}
                    </div>
                  </div>
                  <div
                    class="px-8 w-full flex justify-content-between flex-column gap-4 sm:flex-row align-items-center"
                  >
                    <div class="field-ctnr pt-6 justify-start gap-5">
                      <div
                        class="mb-2 pr-db font-semibold f14 text-gray-900 w-full"
                      >
                        Homme
                      </div>
                    </div>
                    <div class="field-ctnr pt-6 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="total_hom"
                        >Total</label
                      >
                      <input
                        id="total_hom"
                        type="number"
                        [value]="totalHom"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="devlog_hom"
                        >Dev log</label
                      >
                      <input
                        id="devlog_hom"
                        [value]="maleBycategoryDEV"
                        type="number"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <!--************************TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE***************************-->
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="tech_hom"
                        >Tech</label
                      >
                      <input
                        id="tech_hom"
                        type="number"
                        [value]="maleBycategoryTECYB"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="iad_hom"
                        >IA/D</label
                      >
                      <input
                        id="iad_hom"
                        type="number"
                        [value]="maleBycategoryIA"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="ebus_hom"
                        >E-BUS</label
                      >
                      <input
                        id="ebus_hom"
                        type="number"
                        [value]="maleBycategoryEB"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="cca_hom"
                        >CCA</label
                      >
                      <input
                        id="cca_hom"
                        type="number"
                        [value]="maleBycategoryCCA"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                  </div>
                  <div
                    class="px-8 w-full flex justify-content-between flex-column gap-4 sm:flex-row align-items-center"
                  >
                    <div class="field-ctnr pt-6 justify-start gap-5">
                      <div
                        class="mb-2 font-semibold pr-db f14 text-gray-900 w-full"
                      >
                        Femme
                      </div>
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 pr-db font-semibold text-gray-400 w-full"
                        for="total_fem"
                        >Total</label
                      >
                      <input
                        id="total_fem"
                        type="number"
                        [value]="totalFem"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="devlog_fem"
                        >Dev log</label
                      >
                      <input
                        id="devlog_fem"
                        type="number"
                        [value]="femaleBycategoryDEV"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="tech_fem"
                        >Tech</label
                      >
                      <input
                        id="tech_fem"
                        type="number"
                        [value]="femaleBycategoryTECYB"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="iad_fem"
                        >IA/D</label
                      >
                      <input
                        id="iad_fem"
                        type="number"
                        [value]="femaleBycategoryIA"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="ebus_fem"
                        >E-BUS</label
                      >
                      <input
                        id="ebus_fem"
                        type="number"
                        [value]="femaleBycategoryEB"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                    <div class="field-ctnr pt-4 justify-start gap-5">
                      <label
                        class="mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                        for="cca_fem"
                        >CCA</label
                      >
                      <input
                        id="cca_fem"
                        type="number"
                        [value]="femaleBycategoryCCA"
                        class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="self-stretch h-[66px] flex-col justify-start items-start gap-5 flex"
              >
                <div
                  class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex"
                >
                  <div
                    class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
                  >
                    <div
                      class="pt-6 self-stretch text-gray-900 text-4xl font-semibold leading-[38px]"
                    >
                      Délibération
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="pt-6 self-stretch form-ctnr delib-form-one flex-col justify-start items-center gap-4 flex"
              >
                <form
                  class="text-center w-full grow shrink"
                  [formGroup]="paramForm"
                >
                  <div *ngFor="let param of listParam">
                    <div
                      id="dev-logiciel"
                      class="cst-fields-set w-full pr-db gap-6"
                    >
                      <div
                        class="titre-ctnr justify-center w-full self-stretch justify-start gap-6 inline-flex"
                      >
                        <div class="titre f16 font-semibold p-2">
                          Famille de métier
                        </div>
                        <div
                          class="nom f16 text-center font-semibold bg-blue-100 px-3 py-2 w-full rounded-lg"
                        >
                          {{ param.name }}
                        </div>
                      </div>
                      <div
                        class="px-8 w-full flex justify-content-between flex-column gap-4 sm:flex-row align-items-center"
                      >
                        <div class="field-ctnr pt-2 justify-start gap-5">
                          <label
                            class="mb-2 text-sm pt-4 pr-db font-semibold text-gray-700 w-full"
                            for="dl-quota"
                            >Quota
                            <span class="text-white text-sm"
                              >({{
                                param.donneesFamily[0].partCategories[0].c1
                              }}%)</span
                            ></label
                          >
                          <input
                            [formControlName]="'Quota_' + param.id"
                            id="dl-quota"
                            type="number"
                            class="text-center w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 text-center rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex bg-gray-300"
                          />
                        </div>
                        <div class="field-ctnr pt-2 justify-start gap-5">
                          <label
                            class="mb-2 text-sm pt-4 pr-db font-semibold text-gray-700 w-full"
                            for="dl-cat-1"
                            >Catégorie 1
                            <span class="text-gray-300 text-xs"
                              >({{
                                param.donneesFamily[0].partCategories[0].c1
                              }}%)</span
                            ></label
                          >
                          <input
                            [formControlName]="'C1_' + param.id"
                            id="dl-cat-1"
                            type="number"
                            class="text-center w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                          />
                        </div>
                        <div class="field-ctnr pt-2 justify-start gap-5">
                          <label
                            class="mb-2 text-sm pt-4 pr-db font-semibold text-gray-700 w-full"
                            for="dl-cat-2"
                            >Catégorie 2
                            <span class="text-gray-300 text-xs"
                              >({{
                                param.donneesFamily[0].partCategories[0].c2
                              }}%)</span
                            ></label
                          >
                          <input
                            [formControlName]="'C2_' + param.id"
                            id="dl-cat-2"
                            type="number"
                            class="text-center w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                          />
                        </div>
                        <div class="field-ctnr pt-2 justify-start gap-5">
                          <label
                            class="mb-2 text-sm pt-4 pr-db font-semibold text-gray-700 w-full"
                            for="dl-cat-3"
                            >Catégorie 3
                            <span class="text-gray-300 text-sm"
                              >({{
                                param.donneesFamily[0].partCategories[0].c3
                              }}%)</span
                            ></label
                          >
                          <input
                            [formControlName]="'C3_' + param.id"
                            id="dl-cat-3"
                            type="number"
                            class="text-center w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                          />
                        </div>
                        <div class="field-ctnr pt-2 justify-start gap-5">
                          <label
                            class="mb-2 text-sm pt-4 pr-db font-semibold text-gray-700 w-full"
                            for="dl-cat-4"
                            >Catégorie 4
                            <span class="text-gray-300 text-xs"
                              >({{
                                param.donneesFamily[0].partCategories[0].c4
                              }}%)</span
                            ></label
                          >
                          <input
                            [formControlName]="'C4_' + param.id"
                            [id]="'C4_' + param.id"
                            type="number"
                            class="text-center w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                          />
                        </div>
                        <div class="field-ctnr pt-2 justify-start gap-5">
                          <label
                            class="mb-2 text-sm pt-4 pr-db font-semibold text-gray-700 w-full"
                            for="dl-cat-5"
                            >Catégorie 5
                            <span class="text-gray-300 text-sm"
                              >({{
                                param.donneesFamily[0].partCategories[0].c5
                              }}%)</span
                            ></label
                          >
                          <input
                            [formControlName]="'C5_' + param.id"
                            id="dl-cat-5"
                            type="number"
                            class="text-center w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                          />
                        </div>
                        <div class="field-ctnr pt-2 justify-start gap-5">
                          <label
                            class="mb-2 text-sm pt-4 pr-db font-semibold text-gray-700 w-full"
                            for="dl-cat-6"
                            >Catégorie 6
                            <span class="text-gray-300 text-sm"
                              >({{
                                param.donneesFamily[0].partCategories[0].c6
                              }}%)</span
                            ></label
                          >
                          <input
                            [formControlName]="'C6_' + param.id"
                            id="dl-cat-6"
                            type="text"
                            class="text-center w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- ****************  Merci de ne pas supprimer ce code commente ***************************************  -->

                  <!-- <div
              class="form-fields-ctnr btns w-full self-stretch justify-center items-start gap-6 inline-flex"
            >
              <div
                class="text-center w-full flex pt-8 justify-center items-center gap-5"
              >
                <button
                  type="submit"
                  (click)="onRefresh()"
                  class="w-fit text-white mat-mdc-input-element bg-gray-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                >
                  Recharger les données
                </button>
                <button
                  type="submit"
                  (click)="toggleModal()"
                  class="w-fit text-white mat-mdc-input-element dark-blue-bg inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                >
                  Lancer la délibération
                </button>
                <button
                  type="submit"
                  (click)="onReset()"
                  class="w-fit text-white mat-mdc-input-element bg-red-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                >
                  Effacer les données
                </button>
              </div>
            </div> -->
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="showModal"
      tabindex="-1"
      aria-hidden="true"
      class="bg-opacity-70 bg-gray-100 overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
    >
      <div class="relative w-auto my-6 mx-auto max-w-6xl">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
          <!-- Modal content -->
          <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <!--  -->
            <!-- Modal body -->
            <div class="p-4 md:p-5 space-y-4 items-center justify-center">
              <div class="flex justify-center items-center">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
                >
                  <svg
                    class="h-10 w-10 text-red-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                    />
                  </svg>
                </div>
              </div>
              <div class="flex justify-center items-center">
                <p
                  class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400"
                >
                  Vous allez lancer la déliberation. Cette opération peut
                  prendre plus de 20 minutes. Merci de confirmer
                </p>
              </div>
              <div class="flex justify-center items-center">
                <button
                  (click)="onSubmit()"
                  type="button"
                  class="w-full justify-center ml-3 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
                >
                  Confirmer
                </button>
                <button
                  (click)="toggleModal()"
                  type="button"
                  class="mt-3 w-full justify-center ml-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
